module.exports = __webpack_public_path__ + "img/altica_truck&bus.aa133d46.png";